var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEuro(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4308_50992)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 28C21.732 28 28 21.732 28 14C28 6.26801 21.732 0 14 0C6.26801 0 0 6.26801 0 14C0 21.732 6.26801 28 14 28Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0083 18.5797C16.3555 19.0242 15.638 19.25 14.875 19.25C13.2633 19.25 11.8668 18.186 11.109 16.625H14C14.483 16.625 14.875 16.233 14.875 15.75C14.875 15.267 14.483 14.875 14 14.875H10.5735C10.5332 14.5897 10.5 14.2993 10.5 14C10.5 13.7007 10.5332 13.4103 10.5735 13.125H14.875C15.358 13.125 15.75 12.733 15.75 12.25C15.75 11.767 15.358 11.375 14.875 11.375H11.109C11.8668 9.814 13.2633 8.75 14.875 8.75C15.638 8.75 16.3555 8.97575 17.0083 9.42025C17.4055 9.6915 17.9515 9.5935 18.2228 9.191C18.494 8.792 18.3925 8.24775 17.9918 7.97475C17.0573 7.33775 15.9793 7 14.875 7C12.3113 7 10.1168 8.81475 9.205 11.375H7.875C7.392 11.375 7 11.767 7 12.25C7 12.733 7.392 13.125 7.875 13.125H8.827C8.7955 13.4155 8.75 13.7007 8.75 14C8.75 14.2993 8.7955 14.5845 8.827 14.875H7.875C7.392 14.875 7 15.267 7 15.75C7 16.233 7.392 16.625 7.875 16.625H9.205C10.1168 19.1853 12.3113 21 14.875 21C15.9793 21 17.0573 20.6622 17.9918 20.0252C18.3925 19.7522 18.494 19.208 18.2228 18.809C17.9515 18.41 17.4038 18.3102 17.0083 18.5797Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4308_50992"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuro);
export default __webpack_public_path__ + "static/media/euro.4990dafae34e4d321cce14f7383be678.svg";
export { ForwardRef as ReactComponent };